export default __webpack_public_path__ + "static/media/aws_logo.d9d5931c.png";